     <!-- ========================  Facility ======================== -->

     <section class="page">

        <!-- ===  Page header === -->

        <div class="page-header" style="background-image:url(assets/images/header-1.jpg)">
            <div class="container text-center">
                <h2 class="title">Restaurant</h2>
                <p>Meals available from vendors</p>
            </div>
        </div>

    </section>

    <section class="cards">

        <div class="container">
                <div class="row">
                       <!-- === item === -->
        
                       <div class="col-xs-4 col-md-4">
                            <figure>
                                <figcaption style="background-image:url(assets/images/mcd-1.png)">
                                    <img src="assets/images/mcd-1.png" alt="" />
                                </figcaption>
                                <a class="btn btn-clean">MAC FEAST</a>
                            </figure>
                        </div>

        
                        <!-- === item === -->
        
                        <div class="col-xs-4 col-md-4">
                            <figure>
                                <figcaption style="background-image:url(assets/images/mcd-3.png)">
                                    <img src="assets/images/mcd-3.png" alt="" />
                                </figcaption>
                                <a class="btn btn-clean">BIG MAC</a>
                            </figure>
                        </div>
        
                        <!-- === item === -->
        
                        <div class="col-xs-4 col-md-4">
                            <figure>
                                <figcaption style="background-image:url(assets/images/mcd-1.png)">
                                    <img src="assets/images/mcd-1.png" alt="" />
                                </figcaption>
                                <a class="btn btn-clean">MCDONALD</a>
                            </figure>
                        </div>

                           <!-- === item === -->
        
                           <div class="col-xs-4 col-md-4">
                                <figure>
                                    <figcaption style="background-image:url(assets/images/mcd-2.png)">
                                        <img src="assets/images/mcd-2.png" alt="" />
                                    </figcaption>
                                    <a class="btn btn-clean">KFC</a>
                                </figure>
                            </div>

                             <!-- === item === -->
        
                        <div class="col-xs-4 col-md-4">
                                <figure>
                                    <figcaption style="background-image:url(assets/images/nando-1.jpeg)">
                                        <img src="assets/images/nando-1.jpeg" alt="" />
                                    </figcaption>
                                    <a class="btn btn-clean">KFC</a>
                                </figure>
                            </div>
            
                            <!-- === item === -->
            
                            <div class="col-xs-4 col-md-4">
                                <figure>
                                    <figcaption style="background-image:url(assets/images/nando-2.jpeg)">
                                        <img src="assets/images/nando-2.jpeg" alt="" />
                                    </figcaption>
                                    <a class="btn btn-clean">KFC</a>
                                </figure>
                            </div>
        
                    </div> <!--/row-->

        </div> <!--/container-->
    </section>



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/restaurant/restaurant.component.html